// import React from "react";
// import { Navigate } from "react-router-dom";
// import Main from "./layout/Main";

// import { useAuthContext } from "../context/AuthContext";
// const PrivateRoute = ({ children }) => {

//   const { userProfile } = useAuthContext()
//   let token = localStorage.getItem("token") ? localStorage.getItem("token") : null;

//   return token ? (
//     <>
//       <Main>{children}</Main>
//     </>
//   ) : (
//     <>
//       <Navigate to="/sign-in" />
//       {/* <Main>{children}</Main> */}
//     </>
//   );
// };

// export default PrivateRoute;

import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import Main from './layout/Main';
import { AuthContext } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
    const { userProfile } = useContext(AuthContext);
    if (userProfile) {
      console.log(userProfile.is_subscribed , "23456789")
        if (userProfile.is_subscribed || userProfile.user?.is_subscribed) {
            return <Main>{children}</Main>;
        } else {
            return <div>{children}</div>
        }
    } else {
        return <Navigate to="/sign-in" />;
    }
};

export default PrivateRoute;
